import clsx from "clsx";
import AlertTriangle from "./icons/AlertTriangle";

const TONES = {
  danger: "bg-danger-bg text-danger border-danger-border",
  warn: "bg-warn-bg text-warn border-warn-border",
  info: "bg-surface-muted text-text border-border",
  ok: "bg-success-bg text-success-ink border-success",
};

const Svg = ({ children }) => (
  <svg aria-hidden="true" width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round">
    {children}
  </svg>
);

// Mock ICON.info / ICON.ok; danger and warn keep the triangle.
const ICONS = {
  info: (
    <Svg>
      <circle cx="12" cy="12" r="9" />
      <path d="M12 16v-4M12 8h.01" />
    </Svg>
  ),
  ok: (
    <Svg>
      <circle cx="12" cy="12" r="9" />
      <path d="M8 12l3 3 5-6" />
    </Svg>
  ),
};

// Danger and warn interrupt (role=alert); info and ok are polite (role=status, B-35).
function Banner({ tone = "danger", children, className }) {
  const urgent = tone === "danger" || tone === "warn";
  return (
    <div
      role={urgent ? "alert" : "status"}
      data-tone={tone}
      className={clsx("flex items-start gap-2 rounded-2xl border px-4 py-3 text-sm", TONES[tone], className)}>
      <span data-testid={`banner-icon-${ICONS[tone] ? tone : "alert"}`} className="mt-0.5 shrink-0">
        {ICONS[tone] || <AlertTriangle />}
      </span>
      <div>{children}</div>
    </div>
  );
}

export default Banner;
